import styled from 'styled-components';

const StyledHalfColTextFlex = styled.div`
  position: relative;
  flex: 0 0 58.33%;
  width: 58.33%;
  @media screen and (max-width: 767px){
    flex: 0 0 100%;
    width: 100%;
  }
  .intro--text{
    color: ${props => props.theme.colors.grey_700};
    padding-bottom: 80px;
  }
  @media screen and (max-width: 1439px){
    .intro--text{
      padding-bottom: 64px;
    }
  }
  @media screen and (max-width: 1023px){
    .intro--text{
      padding-bottom: ${props => props.theme.components_spacing_tablet.medium}px;
    }
  }
  @media screen and (max-width: 767px){
    .intro--text{
      padding-bottom: ${props => props.theme.components_spacing_mobile.medium}px;
    }
  }
`;

export {
  StyledHalfColTextFlex,
};

